import type { MerrRequest } from '@setplex/merr'
import type { RequestPolicy } from './request'
import type { RetryPolicy } from './retry'
import { TInit, TRequest, TResponse } from '@setplex/merr'
import { durationFromColor } from './colors'
import { logger } from './lib'

//
// debug api policies
//

export function debugPolicies(request: RequestPolicy, retry: RetryPolicy) {
  logger.debug('Request Policy:', request)
  logger.debug('Retry Policy:', retry)

  // expose some debug handlers for request and retry policies
  Object.defineProperty(globalThis, 'DEBUG_POLICY', {
    get() {
      return {
        addSuccess(bucket: string) {
          const part = bucket.startsWith('v') ? 'api/' + bucket : bucket
          request.success(`/wbs/web/${part}/debug`)
          request.buckets.debugPrint()
        },
        addFailure(bucket: string, retryAfter = 0, color = 0) {
          const part = bucket.startsWith('v') ? 'api/' + bucket : bucket
          const req: MerrRequest = new Request(`/wbs/web/${part}/debug`)
          const now = Date.now()
          const duration = durationFromColor(color)
          req.__ = {
            timings: [
              new TInit(now - duration),
              new TRequest(now - duration),
              new TResponse(now),
            ],
          }
          request.failure(req, retryAfter)
          request.buckets.debugPrint()
        },
        clear() {
          request.buckets.clear()
          request.buckets.debugPrint()
        },
        buckets() {
          request.buckets.debugPrint()
        },
      }
    },
  })
}
